import React, { useContext, useEffect, useState } from "react";
import {
  getInvoiceText,
  getPOSInvoiceImage,
  getRegenerateInvoice,
  getViewInvoice,
  getViewInvoiceWebVersion,
  getViewInvoiceWebVersionHtml,
} from "../../services/ViewInvoice/getViewInvoice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getSelectedInvoiceType,
  getStoreInvoicePrinter,
  getStoreNormalA5A4Printer,
  getStorePOSEnabled,
  getStorePOSInvoicePrinterReceiptType,
  getStorePOSInvoicePrinterValue,
  getUserData,
  setSelectedInvoiceType,
} from "../../utils/localStorage";
import StoreMenu from "../StoreMenu";
import { Button } from "primereact/button";
import AdminMenu from "../AdminMenu";

import qz from "qz-tray";
import ButtonLink from "../../ButtonLink";
import SuccessModal from "../SuccessModal";
import { STORE_BASE_URL } from "../../services/BaseURL";

const ViewInvoice = () => {
  const location = useLocation();
  const { storeIdValue, storeCustomerId, bookingOrderId, navigateThrough } =
    location.state || {}; // Fallback to prevent undefined errors

  const { storeData, userProfileRole } = getUserData();

  const userRole = userProfileRole;
  const storeId = storeData.id;
  let requiredStoreId = storeId != null ? storeId : storeIdValue;

  const [orderInvoice, setOrderInvoice] = useState({});
  const [orderInvoiceWeb, setOrderInvoiceWeb] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState("");
  const [orderInvoiceText, setOrderInvoiceText] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [webVersionHtml, setWebVersionHtml] = useState("");
  const [pOSOrderInvoiceImage, setPOSOrderInvoiceImage] = useState({})

   const [storePOSEnabledValue, setStorePOSEnabledValue] = useState("");
    const [invoicePrinterPOSValue, setInvoicePrinterPOSValue] = useState("");
    const [invoicePrinterReceiptType, setInvoicePrinterReceiptType] = useState("");
  
    const fetchStorePOSMachine = async () => {
      try {
        const selectedTagPrinterData = await getStorePOSEnabled();
  
        const value =
          selectedTagPrinterData?.storePOSEnabled === true ||
          selectedTagPrinterData?.storePOSEnabled === "true";
        
          if(value) {
            setType("mini")
          }
        setStorePOSEnabledValue(value);
      } catch {
        setStorePOSEnabledValue(false);
      }
    };

  const fetchStorePOSReceiptType = async () => {
    try {
      const ReceiptType = await getStorePOSInvoicePrinterReceiptType();

      const value =
        ReceiptType?.invoicePrinterPOSReceiptTypeValue === true ||
        ReceiptType?.invoicePrinterPOSReceiptTypeValue === "true";

      if (value) {
        setType("mini")
      }
      setInvoicePrinterReceiptType(value);
    } catch {
      setInvoicePrinterReceiptType(false);
    }
  };
  
    const fetchSelectedPOSInvoicePrinterValue = async () => {
        try {
          const invoicePrinterPOSValue = await getStorePOSInvoicePrinterValue();
          setInvoicePrinterPOSValue(invoicePrinterPOSValue?.invoicePrinterPOSValue || "");
        } catch {
          setInvoicePrinterPOSValue("");
        }
      };

  const fetchGetViewInvoice3 = async () => {
    try {
      // const invoiceResponse = await getViewInvoice3(
      const invoiceResponse = await getViewInvoiceWebVersionHtml(
        storeCustomerId,
        requiredStoreId,
        bookingOrderId
      );
      if (!invoiceResponse.data?.error) {
        setWebVersionHtml(invoiceResponse.data);
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  };
  const fetchInvoice = async () => {
    try {
      const invoiceResponse = await getViewInvoice(
        storeCustomerId,
        requiredStoreId,
        bookingOrderId
      );
      if (!invoiceResponse.data?.error) {
        setOrderInvoice(invoiceResponse.data);
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  };

  const fetchPOSInvoiceImage = async () => {
    try {
      const invoiceResponse = await getPOSInvoiceImage(
        storeCustomerId,
        bookingOrderId
      );
      if (!invoiceResponse.data?.error) {
        setPOSOrderInvoiceImage(invoiceResponse);
      }
    } catch (error) {
      console.error("Error fetching invoice:", error);
    }
  };

  
  const fetchInvoiceWebVersion = async (invoiceType) => {
    try {
      const invoiceResponse = await getViewInvoiceWebVersion(
        storeCustomerId,
        requiredStoreId,
        bookingOrderId,
        invoiceType
      );
      if (!invoiceResponse.data?.error) {
        setOrderInvoiceWeb(invoiceResponse.data);
      }
    } catch (error) {
      console.error("Error fetching web version of invoice:", error);
    }
  };

  const fetchInvoiceText = () => {
    getInvoiceText(storeCustomerId, requiredStoreId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderInvoiceText(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleInvoiceTypeChange = async (selectedType) => {
    setType(selectedType);
    await setSelectedInvoiceType(selectedType);
    fetchInvoice();
    fetchInvoiceWebVersion(selectedType);
  };
  const fetchSelectedInvoiceType = async () => {
    try {
      const selectedInvoiceTypeData = await getSelectedInvoiceType();
      setType(selectedInvoiceTypeData?.invoiceType || "a5");
      fetchInvoice();
      if (selectedInvoiceTypeData?.invoiceType !== null) {
        fetchInvoiceWebVersion(selectedInvoiceTypeData?.invoiceType);
      } else {
        fetchInvoiceWebVersion("a5");
      }
    } catch {
      setType("a5");
      fetchInvoice();
      fetchInvoiceWebVersion("a5");
    }
  };
  useEffect(() => {
    fetchInvoiceText();
    fetchSelectedInvoiceType();
    fetchGetViewInvoice3();
    fetchPOSInvoiceImage();
  }, []);

  const navigate = useNavigate();

  const pdfDataUri = `data:application/pdf;base64,${orderInvoiceWeb?.invoice}`;

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  const [normalA5A4PrinterValue, setNormalA5A4PrinterValue] = useState("");

  const fetchSelectedNormalA5A4Printer = async () => {
    try {
      const selectedNormalA5A4PrinterData = await getStoreNormalA5A4Printer();
      setNormalA5A4PrinterValue(
        selectedNormalA5A4PrinterData?.normalA5A4Printer || ""
      );
    } catch {
      setNormalA5A4PrinterValue("");
    }
  };

  function printPOSImage() {

    // const payload = "https://api.bill.ind.in/bi/dev/di/1603261100071vt8SrBX";
    // const payload = STORE_BASE_URL + "/store/api/secure/v1/download-invoice/" + storeCustomerId + "/" + bookingOrderId + "/web"
    const payload = STORE_BASE_URL + "/store/api/secure/v1/download-invoice/" + storeCustomerId + "/" + bookingOrderId
    const imgUrl = encodeURIComponent(payload);

    window.location.href =
      `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2&printer-id=${invoicePrinterPOSValue}&printer-type=${invoicePrinterReceiptType ? "RECEIPT_AC" : "RECEIPT_NC"}`;
  }

  const [isConnected, setIsConnected] = useState(false);
  const [printerList, setPrinterList] = useState([]);

  useEffect(() => {
    if (!isConnected) {
      connectToQZ();
    }

    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
    fetchStorePOSMachine();
    fetchStorePOSReceiptType();
    fetchSelectedPOSInvoicePrinterValue();
  }, []);

  const connectToQZ = async () => {
    // qz.api.setSha256Type(data => window.crypto.subtle.digest("SHA-256", new TextEncoder("utf-8").encode(data)));

    // qz.security.setCertificatePromise(() => {
    //   return fetch("/certs/qz-tray.crt")
    //     .then(res => res.text());
    // });

    // qz.security.setSignaturePromise(toSign => {
    //   return fetch("http://192.168.1.34:3000/sign-message", {
    //     method: "POST",
    //     headers: { "Content-Type": "text/plain" },
    //     body: toSign
    //   }).then(res => res.text());
    // });

    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  const findPrinters = async () => {
    try {
      const printers = await qz.printers.find();
      setPrinterList(printers);
    } catch (err) {
      console.error("Failed to find printers:", err);
    }
  };

  // const printImage = async () => {
  //   try {
  //     const printer = await qz.printers.find("POS-80"); // Replace with your actual printer name
  //     const config = qz.configs.create(printer);

  //     // Load and convert image to Base64
  //     const imageUrl = "https://via.placeholder.com/150"; // Replace with your actual image URL
  //     // const base64 = await convertImageToBase64(orderInvoice.invoice);
  //     const base64 = orderInvoice.invoice

  //     const data = [
  //       {
  //         type: "image",
  //         format: "base64",
  //         data: base64,
  //       },
  //     ];

  //     await qz.print(config, data);
  //     alert("Image sent to printer!");
  //   } catch (err) {
  //     console.error("Print failed:", err);
  //     alert("Failed to print image");
  //   }
  // };

  const printImage = async () => {
    try {
      const printer = await qz.printers.find(invoicePrinterValue); // Replace with your actual printer name

      // Set custom size for the image in pixels (width x height)
      const config = qz.configs.create(printer, {
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      // Load base64 image from state/prop (already prepared)
      const base64 = orderInvoice.invoice;

      const data = [
        {
          type: "image",
          format: "base64",
          data: base64,
        },
      ];

      await qz.print(config, data);
      // alert("Image sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print image");
    }
  };

  const printPdfA5 = async () => {
    try {
      const printer = await qz.printers.find(normalA5A4PrinterValue); // Replace with your actual printer name

      // Set custom size for the image in pixels (width x height)
      const config = qz.configs.create(printer, {
        size: { width: 5.83 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      // Load base64 image from state/prop (already prepared)
      const base64 = orderInvoiceWeb?.invoice;

      const data = [
        {
          type: "pdf",
          format: "base64",
          data: base64,
        },
      ];

      await qz.print(config, data);
      // alert("Pdf sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print pdf");
    }
  };
  const printPdfA4 = async () => {
    try {
      const printer = await qz.printers.find(normalA5A4PrinterValue); // Replace with your actual printer name

      // Set custom size for the image in pixels (width x height)
      const config = qz.configs.create(printer, {
        size: { width: 8.27 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      // Load base64 image from state/prop (already prepared)
      const base64 = orderInvoiceWeb?.invoice;

      const data = [
        {
          type: "pdf",
          format: "base64",
          data: base64,
        },
      ];

      await qz.print(config, data);
      // alert("Pdf sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print pdf");
    }
  };

  const printInvoiceHTML = async () => {
    try {
      const printer = await qz.printers.find(invoicePrinterValue); // Adjust to your printer's actual name
      const config = qz.configs.create(printer, {
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const htmlContent = `
        <html>
          <body style="font-size: 12px;">
            <div style="text-align: center;">
              <h2>My Store</h2>
              <p>Invoice #12345</p>
              <hr />
            </div>
            <p>Item 1 ............ $10.00</p>
            <p>Item 2 ............ $15.00</p>
            <hr />
            <p>Total: $25.00</p>
            <div style="text-align: center;">
              <p>Thank you!</p>
            </div>
          </body>
        </html>
      `;

      await qz.print(config, [
        {
          type: "html",
          format: "plain",
          data: webVersionHtml.invoice,
          // data: htmlContent,
          // webVersionHtml.invoice
        },
      ]);
      // alert("HTML invoice sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print invoice");
    }
  };

  const handleRegenerateInvoice = () => {
    getRegenerateInvoice(requiredStoreId, storeCustomerId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setModalVisible(true);
          setModalStatus("success");
          setModalText("Invoice Re-generated Successfully");
          fetchInvoiceText();
          fetchSelectedInvoiceType();
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => {
                    userRole === "BY_ADMIN" || userRole === "BY_FRANCHISE_ADMIN"
                      ? navigateThrough === "GoBack"
                        ? navigate(-1)
                        : navigate("/OrdersGarmentInfo", {
                            state: {
                              storeIdValue: storeIdValue,
                              bookingOrderId: bookingOrderId,
                              storeCustomerId: storeCustomerId,
                            },
                          })
                      : navigateThrough === "GoBack"
                        ? navigate(-1)
                        : navigate("/OrdersGarmentInfo", {
                            state: {
                              bookingOrderId: bookingOrderId,
                              storeCustomerId: storeCustomerId,
                            },
                          });
                  }}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Order Invoice
              </p>
            </div>
          </div>

          {storePOSEnabledValue && invoicePrinterPOSValue && (
          <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="POS Print"
                onClick={() => printPOSImage()}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: "#2B70D7",
                  backgroundColor: "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>
          )}

          {!orderInvoice.invoice && (
            <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="Regenerate"
                onClick={() => handleRegenerateInvoice()}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: "#2B70D7",
                  backgroundColor: "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>
          )}
          {type !== "mini" && normalA5A4PrinterValue && (
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={type === "a4" ? printPdfA4 : printPdfA5}
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          )}
          {type === "mini" && invoicePrinterValue && (
            <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={
                  printImage
                  // printInvoiceHTML
                }
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>
          )}
          {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer">
            <Button
              label="A4"
              onClick={() => handleInvoiceTypeChange("a4")}
              className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
              style={{
                color: type === "a4" ? "#fff" : "#2B70D7",
                backgroundColor: type === "a4" ? "red" : "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>}
          {!storePOSEnabledValue &&<div className="flex justify-content-center align-items-center cursor-pointer">
            <Button
              label="A5"
              onClick={() => handleInvoiceTypeChange("a5")}
              className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
              style={{
                color: type === "a5" ? "#fff" : "#2B70D7",
                backgroundColor: type === "a5" ? "red" : "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>}
          {!storePOSEnabledValue &&<div className="flex justify-content-center align-items-center cursor-pointer">
            <Button
              label="MINI"
              onClick={() => handleInvoiceTypeChange("mini")}
              className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
              style={{
                color: type === "mini" ? "#fff" : "#2B70D7",
                backgroundColor: type === "mini" ? "red" : "#fff",
                borderColor: "#2B70D7",
              }}
            ></Button>
          </div>}
          <div
            className="flex justify-content-center align-items-center cursor-pointer mx-2"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      {/*<div className="flex ">
        <div className="flex flex-1 justify-content-center print-section">
      <div
        dangerouslySetInnerHTML={{ __html: webVersionHtml.invoice }}
            style={{
              width: "284px" }}
      />
        </div>
      </div>*/}

      {type !== "mini" ? (
        <div className="flex ">
          <div className="flex flex-1 justify-content-center print-section">
            {orderInvoiceWeb && (
              <iframe
                src={pdfDataUri}
                title="PDF Preview"
                width="100%"
                height="600px"
              />
            )}
          </div>
        </div>
      ) : (
        <div className="flex justify-content-center relative">
          <img
            className="print-section"
            src={`data:image/jpeg;base64,${orderInvoice.invoice}`}
            resizeMode="cover"
            style={{
              alignSelf: "center", // to center an image
              // width: "100%",
            }}
          />

            {!storePOSEnabledValue && <div
            className="ml-4 cursor-pointer fixed z-2 right-0"
            onClick={() => window.print()}
          >
            <img
              src={"Icons/printer.png"}
              style={{
                width: 65,
              }}
            />
          </div>}
        </div>
      )}
      <div></div>

      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <ButtonLink />
          <StoreMenu setVisible={setVisible} visible={visible} />
        </>
      )}

      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ViewInvoice;
